import { useState } from "react";
import {
  BedDouble,
  Bath,
  Car,
  ShieldCheck,
  Bell,
  Dumbbell,
  MessageSquare,
  ChevronDown,
  ChevronUp,
} from "lucide-react";

export const PropertyDetails = ({ PropertyData }) => {
  const [expanded, setExpanded] = useState(false);

  const Item = ({ icon: Icon, label }) => (
    <div className="flex items-center gap-3 text-gray-600 text-base font-medium">
      <Icon size={20} />
      <span>{label}</span>
    </div>
  );

  const Title = ({ title }) => (
    <div className="text-base font-semibold text-gray-900 mb-4">{title}</div>
  );

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-6 md:p-8">
      {/* Title */}
      <div className="text-2xl font-semibold text-gray-900 mb-6">
        Property features
      </div>

      {/* ===== Bedrooms & Bathrooms ===== */}
      <div className="mb-6">
        <Title title="Bedrooms & bathrooms" />
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4">
          {PropertyData?.Ensuites && (
            <Item icon={Bath} label={`Ensuites: ${PropertyData?.Ensuites}`} />
          )}
          {PropertyData?.Bedrooms && (
            <Item
              icon={BedDouble}
              label={`Bedrooms: ${PropertyData?.Bedrooms}`}
            />
          )}
        </div>
      </div>

      {/* ===== Parking ===== */}
      <div className="mb-6">
        <Title title="Parking" />
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4">
          {PropertyData?.garage_spaces && (
            <Item
              icon={Car}
              label={`Garage spaces: ${PropertyData?.garage_spaces}`}
            />
          )}
          {PropertyData?.carport_spaces && (
            <Item icon={ShieldCheck} label="Secure parking" />
          )}
        </div>
      </div>

      {/* ===== Indoor Features ===== */}
      <div>
        <Title title="Indoor features" />
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4">
          <Item icon={Bell} label="Alarm system" />
          <Item icon={Dumbbell} label="Gym" />
          <Item icon={MessageSquare} label="Intercom" />

          {expanded && (
            <>
              <Item icon={ShieldCheck} label="Built-in wardrobes" />
              <Item icon={Bath} label="Air conditioning" />
            </>
          )}
        </div>

        {/* Show Toggle */}
        <div
          onClick={() => setExpanded(!expanded)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter") setExpanded(!expanded);
          }}
          className="mt-4 inline-flex items-center gap-1 text-[#097FE6] text-base font-medium cursor-pointer transition-colors duration-200 hover:text-[#43a0f1]"
        >
          <span className="relative">
            {expanded ? "Show less" : "Show more"}
            <span className="absolute left-0 -bottom-0.5 w-0 h-[1px] bg-[#16304f] transition-all duration-200 group-hover:w-full"></span>
          </span>

          {expanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </div>
      </div>
    </div>
  );
};
